import i18n from "@/i18n";
import { IMenuRoute } from "@/models/routes";

export function AdminMenuRoutes(): IMenuRoute[] {
  return [
    {
      order: 3, // Position after `Products & Services`
      label: i18n.t("_modules.web_hosting.web_hosting.host_control"),
      icon: "server",
      to: {
        name: "admin__hostControl"
      },
      children: [
        {
          label: i18n.t("_modules.web_hosting.domains.domain_names"),
          to: {
            name: "admin__hostControl::domains"
          }
        },
        {
          label: i18n.t("_modules.web_hosting.web_hosting.web_hosting"),
          to: {
            name: "admin__hostControl::hosting"
          }
        }
      ]
    }
  ];
}

export function DomainNamesTabigation(): IMenuRoute[] {
  return [
    {
      label: i18n.t("_modules.web_hosting.domains.registrars"),
      to: {
        name: "admin__hostControl::domainRegistrars"
      }
    },
    {
      label: i18n.t("_modules.web_hosting.domains.tlds"),
      to: {
        name: "admin__hostControl::domainTlds"
      }
    },
    {
      label: i18n.t("_modules.web_hosting.web_hosting.widgets"),
      to: {
        name: "admin__hostControl::domainWidgets"
      }
    },
    {
      label: i18n.t("_.settings"),
      to: {
        name: "admin__hostControl::settings"
      }
    }
  ];
}

export function WebHostingTabigation(): IMenuRoute[] {
  return [
    {
      label: i18n.t("_modules.web_hosting.web_hosting.web_servers"),
      to: {
        name: `admin__hostControl::hostingConfigurations`
      }
    },
    {
      label: i18n.t("_modules.web_hosting.web_hosting.hosting_packages"),
      to: {
        name: "admin__hostControl::hostingPackages"
      }
    }
  ];
}
